import Box from "../../../../components/Box";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import { InOutListModel, InOutListModelDetailModel, InOutListModelServiceModel } from "../CalculateList";
import { Helpers } from "../../../../helpers/Helpers";

interface Props {
    inOutList: InOutListModel[]
    setInOutList: React.Dispatch<React.SetStateAction<InOutListModel[]>>
    setInOutDetailList: React.Dispatch<React.SetStateAction<InOutListModelDetailModel[]>>
    inOutDetailList: InOutListModelDetailModel[]
    setInOutServiceList: React.Dispatch<React.SetStateAction<InOutListModelServiceModel[]>>
    inOutServiceList: InOutListModelServiceModel[]
    isIn: boolean
    isOut: boolean
}

const DeclarationInformation = ({
    inOutList,
    setInOutList,
    setInOutDetailList,
    inOutDetailList,
    setInOutServiceList,
    inOutServiceList,
    isIn,
    isOut
}: Props) => {

    const selectAll = () => {
        var isAllSelected = inOutList.length == inOutList.filter(x => x.isSelected).length;

        setInOutList(inOutList.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const setItemSelected = (_id: string) => {
        setInOutList(inOutList.map(function (x) {
            if (x.entityId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const groupProductList = (_list: InOutListModelDetailModel[]) => {
        // return _list;

        var newList: InOutListModelDetailModel[] = [];

        for (var i = 0; i < _list.length; i++) {
            var item = _list[i];

            var control = newList.find(x =>
                x.ledgerNo == item.ledgerNo &&
                x.productKindName == item.productKindName &&
                x.potTypeName == item.potTypeName &&
                (isOut ? x.startDate?.split('T')[0].split(' ')[0] == item.startDate?.split('T')[0].split(' ')[0] : true) &&
                (/*isIn ?*/ x.endDate?.split('T')[0].split(' ')[0] == item.endDate?.split('T')[0].split(' ')[0] /*: true*/)
            )

            if (control) {
                if (isIn) {
                    control.stockPotQuantity = (Helpers.toNumber(control.stockPotQuantity) + Helpers.toNumber(item.stockPotQuantity)).toString();
                    control.stockGrossWeight = (Helpers.toNumber(control.stockGrossWeight) + Helpers.toNumber(item.stockGrossWeight)).toString();
                    control.stockVolume = (Helpers.toNumber(control.stockVolume) + Helpers.toNumber(item.stockVolume)).toString();
                    control.stockArea = (Helpers.toNumber(control.stockArea) + Helpers.toNumber(item.stockArea)).toString();
                }

                control.processPotQuantity = (Helpers.toNumber(control.processPotQuantity) + Helpers.toNumber(item.processPotQuantity)).toString();
                control.processGrossWeight = (Helpers.toNumber(control.processGrossWeight) + Helpers.toNumber(item.processGrossWeight)).toString();
                control.processVolume = (Helpers.toNumber(control.processVolume) + Helpers.toNumber(item.processVolume)).toString();
                control.processArea = (Helpers.toNumber(control.processArea) + Helpers.toNumber(item.processArea)).toString();
                // control.palletCount = (Helpers.toNumber(control.palletCount) + Helpers.toNumber(item.palletCount)).toString();
                // control.containerCount = (Helpers.toNumber(control.containerCount) + Helpers.toNumber(item.containerCount)).toString();
                // control.vehicleCount = (Helpers.toNumber(control.vehicleCount) + Helpers.toNumber(item.vehicleCount)).toString();
            }
            else {
                newList.push(item);
            }
        }

        return newList;
    }

    const addToList = () => {
        var noRefList1: InOutListModel[] = JSON.parse(JSON.stringify(inOutList));
        var oldList: any = noRefList1.filter(x => x.isSelected).map(x => x.details);
        var newDetails: InOutListModelDetailModel[] = [].concat.apply([], oldList);
        newDetails = groupProductList(newDetails);
        setInOutDetailList(newDetails);

        var noRefList2: InOutListModel[] = JSON.parse(JSON.stringify(inOutList));
        var oldList2: any = noRefList2.filter(x => x.isSelected).map(x => x.services);
        var newDetails2: InOutListModelServiceModel[] = [].concat.apply([], oldList2);
        setInOutServiceList(newDetails2);
    }

    return (
        <div className='containerPart' /*ref={vehicleInformationRef}*/>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Beyanname Bilgileri</h4>

                    <Box className={"mt-5"} flexDirection="row">
                        <Box onClick={inOutList.filter(x => x.isSelected).length > 0 ? () => addToList() : undefined} opacity={inOutList.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-plus" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Listeye Ekle</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                        <input onChange={selectAll} className='form-check-input' type='checkbox' checked={inOutList.filter(x => x.isSelected).length > 0 && inOutList.filter(x => x.isSelected).length == inOutList.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Defter No</th>
                                            <th>Antrepo Beyan No</th>
                                            <th>Antrepo Beyan Tarihi</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            inOutList.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            inOutList.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                <input onChange={() => setItemSelected(item.entityId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>{item.ledgerNo}</td>
                                                    <td>{item.antrepoDeclarationNo}</td>
                                                    <td>{item.antrepoDeclarationDateStr}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default DeclarationInformation;